import { Helpers, Utils } from '../../Core';
import { getCmsDeliveryApi as API } from '../../Apis';
import { mocksService } from './GetCobrandedCommonQuestions.mocks';
import dataFields from '../../Types/CmsCobrandedCard.json';
import { GetCobrandedCommonQuestionsServiceResponse } from '../../Types/internals/CmsCobrandedCommonQuestions.internals.type';
import { CommonQuestionsData } from '../../Types/CmsCobrandedCommonQuestions.types';
import { duplicateBrTags } from '../../Utils';

const prepareCall = async () => {
  const { cmsDeliveryIds } = Helpers.getConstants();
  const { FREQUENT_QUESTIONS } = cmsDeliveryIds as {
    [key: string]: string;
  };

  return API.call.get({
    contentId: FREQUENT_QUESTIONS,
  });
};

const handleSucessFinalResponseFunction = (
  result: GetCobrandedCommonQuestionsServiceResponse,
): CommonQuestionsData[] => {
  const { content } = result;
  const ids = new Set(Object.keys(content).map((key) => key.split('-')[1]));
  const faq = [];

  for (const i of ids) {
    faq.push({
      question: content[`pergunta-${i}`],
      answer: duplicateBrTags(content[`resposta-${i}`]),
    });
  }
  return faq;
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction: prepareCall,
  definitionsAPI: API.definitions,
  handleResponse: { handleSucessFinalResponseFunction },
  mocksService,
  dataFields,
});
